// Imports
import { fetchBinaryBlob } from "./fetchBinaryBlob"; // Update path as needed

/**
 * Fetches a binary blob from a FHIR attachment reference,
 * which may be a Binary resource or an indirect reference like DocumentReference or Media.
 *
 * @param {Object} attachmentRef - The attachment object with a `url` field
 * @param {Object} fhirClient - An initialized FHIR client with `read()` method
 * @returns {Object} - A result object containing `blob`, `title`, `contentType`, `name`, or error info
 */
export const fetchAttachmentBlob = async (attachmentRef, fhirClient) => {
  console.log("Fetching attachment blob for:", attachmentRef);
  try {
    if (!attachmentRef?.url) {
      return { error: "No URL provided for attachment." };
    }

    const url = attachmentRef.url;

    // Handle direct Binary references
    if (url.startsWith("Binary/")) {
      return await fetchBinaryBlob(url, fhirClient);
    }

    // Handle DocumentReference, Media, etc.
    const resource = await fhirClient.read({ url });
    const attachment =
      resource?.content?.[0]?.attachment ||
      resource?.presentedForm?.[0] ||
      resource?.attachment;

    if (!attachment?.url) {
      return { error: "No attachment URL found in resource." };
    }

    const blobRes = await fetchBinaryBlob(attachment.url, fhirClient);
    return {
      ...blobRes,
      title: attachment.title,
      contentType: attachment.contentType,
      name: attachment.title || resource.id,
    };
  } catch (err) {
    return { error: `Fetch failed: ${err.message}` };
  }
};